/**
 * @generated SignedSource<<a8b2e772cf6e19aea95a75376e96ad93>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type RoutineType = "DEFAULT" | "EVENT_ITEM" | "KPI" | "STANDARD" | "TEMPLATE";
import { FragmentRefs } from "relay-runtime";
export type RoutineEditMainRoutine_Routine$data = {
  readonly canBeConvertedToWeekly: boolean | null;
  readonly canBeConvertedToWorkspaceTemplate: boolean;
  readonly canBeUnarchived: boolean;
  readonly currentSchedule: {
    readonly __typename: string;
  } | null;
  readonly id: string;
  readonly isArchived: boolean;
  readonly isOrg: boolean;
  readonly orgTopic: {
    readonly id: string;
  } | null;
  readonly title: string;
  readonly type: RoutineType;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineEditAssignedRolesListItem_Routine" | "RoutineEditContentCard_Routine" | "RoutineEditScheduleCard_Routine" | "RoutineEditTeamListItem_Routine" | "useIsSaveable_Routine" | "useRoutineEditDirty_Routine" | "useSaveRoutineEdit_routine">;
  readonly " $fragmentType": "RoutineEditMainRoutine_Routine";
};
export type RoutineEditMainRoutine_Routine$key = {
  readonly " $data"?: RoutineEditMainRoutine_Routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineEditMainRoutine_Routine">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoutineEditMainRoutine_Routine",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canBeUnarchived",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isArchived",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOrg",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OrgTopic",
      "kind": "LinkedField",
      "name": "orgTopic",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canBeConvertedToWorkspaceTemplate",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useIsSaveable_Routine"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoutineEditContentCard_Routine"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoutineEditScheduleCard_Routine"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoutineEditTeamListItem_Routine"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSaveRoutineEdit_routine"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useRoutineEditDirty_Routine"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoutineEditAssignedRolesListItem_Routine"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canBeConvertedToWeekly",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentSchedule",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Routine",
  "abstractKey": null
};
})();

(node as any).hash = "91d07d881422e2883fee96a95980eb23";

export default node;
